import deleteIcon from "../Icons/delete.png";
import { v4 as uuid } from "uuid";
import Papa from "papaparse";
import * as XLSX from "xlsx";
import {
  Badge,
  Box,
  Button,
  Divider,
  Flex,
  Image,
  Input,
  Select,
  Stack,
  Table,
  TableContainer,
  Tbody,
  Td,
  Text,
  Tfoot,
  Th,
  Thead,
  Tr,
  useDisclosure,
  useToast,
} from "@chakra-ui/react";
import React, { memo, useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { addFileAPI, editQtyToBeProduced } from "../../Redux/App/app.actions";
import FileUploaderPro from "../FileUploader/FIleUploaderPro";
import DynamicTable from "../DynamicTable/DynamicTable";
import validateExcelData from "../Validations/row_wise_validations";
import ValidationErrors from "./ValidationErrors";
import { useNavigate } from "react-router-dom";

const TestChemistry = ({
  showResults,
  // validationErrors,
  // setValidationErrors,
  fileData,
  setFileData,
}) => {
  const inputFile = useSelector((state) => state?.app?.inputFile);
  const [file, setFile] = useState(inputFile || null);

  const state = useSelector((state) => state.app);

  const dispatch = useDispatch();
  const { isOpen, onOpen, onClose } = useDisclosure();

  const convertCsvToJson = (file) => {
    try {
      Papa.parse(file, {
        header: true,
        dynamicTyping: true,
        skipEmptyLines: true,
        complete: (result) => {
          // console.log("RESULTS : ", result.data);
          setFileData((prev) => result.data);
        },
      });
    } catch (e) {}
  };

  const convertExcelToJson = (file) => {
    try {
      const reader = new FileReader();
      reader.onload = (e) => {
        const result = e.target.result;
        const workbook = XLSX.read(result, { type: "binary" });
        const sheetName = workbook.SheetNames[0];
        const sheet = workbook.Sheets[sheetName];
        const arr = XLSX.utils.sheet_to_json(sheet, { header: 1 });
        const headers = arr[0];
        const rows = arr.slice(1);
        const objects = rows.reduce((acc, row) => {
          // Check if the row has any non-empty cells
          const hasValue = row.some(
            (cell) => cell !== undefined && cell !== null && cell !== ""
          );
          if (hasValue) {
            // If the row has at least one non-empty cell, add it to the objects array
            const obj = {};
            headers.forEach((header, index) => {
              obj[header] = row[index];
            });
            acc.push(obj);
          }
          return acc;
        }, []);
        setFileData((prev) => objects);
      };
      reader.readAsBinaryString(file);
    } catch (e) {}
  };

  const updateFileData = (file) => {
    try {
      if (file) {
        switch (file.type) {
          case "application/vnd.ms-excel": {
            convertExcelToJson(file);
            break;
          }
          case "text/csv": {
            convertCsvToJson(file);
            break;
          }
          default:
            convertExcelToJson(file);
            break;
        }
      } else {
        setFileData([]);
      }
    } catch (e) {}
    //this function converts the uploaded file into array of objects
  };

  // useEffect(() => {
  //   try {
  //     if (fileData && fileData.length > 0) {
  //       let expectedColumns = [
  //         { name: "Lot no.", isRequired: true, type: "number" },
  //         { name: "Premises", isRequired: true, type: "string" },
  //         { name: "Description", isRequired: true, type: "string" },
  //         { name: "Avl.Qty.(MT)", isRequired: true, type: "number" },
  //         { name: "P", isRequired: true, type: "number" },
  //         { name: "SiO2", isRequired: true, type: "number" },
  //         { name: "Cr2O3", isRequired: true, type: "number" },
  //         { name: "FeO", isRequired: true, type: "number" },
  //         { name: "CaO", isRequired: true, type: "number" },
  //         { name: "MgO", isRequired: true, type: "number" },
  //         { name: "Al2O3", isRequired: true, type: "number" },
  //         { name: "Fe2O3", isRequired: true, type: "number" },
  //         { name: "Additional Fe", isRequired: true, type: "number" },
  //         { name: "S", isRequired: true, type: "number" },
  //         { name: "FC", isRequired: true, type: "number" },
  //         { name: "Analysis Status", isRequired: true, type: "string" },
  //         { name: "ASH", isRequired: true, type: "number" },
  //       ];

  //       let errors = validateExcelData(fileData, expectedColumns);
  //       // console.log(errors);
  //       if (errors) {
  //         setTimeout(() => {
  //           onOpen();
  //         }, 1500);
  //         setValidationErrors((prev) => errors);
  //       }
  //     } else {
  //       setValidationErrors((prev) => []);
  //     }
  //   } catch (e) {}
  // }, [fileData]);

  useEffect(() => {
    setFile((prev) => file);
    dispatch(addFileAPI(file));
    updateFileData(file);
  }, [file]);

  useEffect(() => {
    if (inputFile) {
      setFile((prev) => inputFile);
      dispatch(addFileAPI(inputFile));
      updateFileData(inputFile);
    }
  }, [inputFile]);

  return (
    <Box w="100%" m="auto">
      <Flex justify="space-around">
        <Flex p="10px" align="center" boxShadow="lg" borderRadius="5px">
          <Text>Input Ore Material Sum</Text>
          <Input
            disabled={showResults}
            isRequired={true}
            w="100px"
            ml="2rem"
            color="black"
            border={
              state.input_ore_material_sum
                ? "3px solid #e7edf3"
                : "2px solid #fe637f"
            }
            value={state.input_ore_material_sum}
            onChange={(e) => {
              dispatch(editQtyToBeProduced(Number(e.target.value)));
            }}
          />
        </Flex>
        <Box
          border={file ? "2px solid #38a169" : "2px solid #FE637F"}
          borderRadius="5px"
        >
          <FileUploaderPro
            file={file}
            onChange={(file) => setFile((prev) => file)}
          />
        </Box>
        {/* {validationErrors && Object.keys(validationErrors).length > 0 && (
          <Flex justify="right" align="center">
            <Button onClick={onOpen} colorScheme="red">
              view failed validations
            </Button>
            <ValidationErrors
              isOpen={isOpen}
              onOpen={onOpen}
              onClose={onClose}
              errors={validationErrors}
              size="xl"
              title={`${
                Object.keys(validationErrors).length
              }     Records Failed Validations`}
            />
          </Flex>
        )} */}
      </Flex>
      <Box maxW="1150px" m="auto">
        {file && (
          <DynamicTable
            height={"50vh"}
            data={fileData}
            headers={[
              "Lot no.",
              "Premises",
              "Description",
              "Avl.Qty.(MT)",
              "P",
              "SiO2",
              "Cr2O3",
              "FeO",
              "CaO",
              "MgO",
              "Al2O3",
              "Fe2O3",
              "Additional Fe",
              "S",
              "FC",
              "Analysis Status",
              "ASH",
            ]}
          />
        )}
      </Box>
    </Box>
  );
};

export default memo(TestChemistry);
